import * as React from 'react';
const GonfioreAddominaleIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M127.76 64.07c0 6.53-1.63 16.47-1.63 21.23 0 19.6 11.43 24.49 11.43 50.62M72.24 64.07c0 6.53 1.63 16.47 1.63 21.23 0 19.6-11.43 24.49-11.43 50.62M100 103.27s-3.13 2.45 0 4.9"
      className="prefix__cls-2"
    />
    <path
      d="M82.51 91.06c5.1-3.09 11.09-4.88 17.49-4.88s12.39 1.78 17.49 4.88M122.5 119.67c-6.56 3.98-14.26 6.27-22.5 6.27s-15.94-2.29-22.5-6.27"
      className="prefix__cls-1"
    />
  </svg>
);
export default GonfioreAddominaleIcon;
